import { render, staticRenderFns } from "./MyProfileEditSection.vue?vue&type=template&id=05cde591&scoped=true"
import script from "./MyProfileEditSection.vue?vue&type=script&lang=js"
export * from "./MyProfileEditSection.vue?vue&type=script&lang=js"
import style0 from "./MyProfileEditSection.vue?vue&type=style&index=0&id=05cde591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cde591",
  null
  
)

export default component.exports